import { fetchData } from '../../global-declare-components/api/network';

const agendaAPI = {
  fetch:(slug, params) => fetchData(`/api/landing-page/${slug}/agenda`, {params})
};

export default agendaAPI;
